<script>
import InfoExclamationMark from "@/components/info/infoExclamationMark.vue"

export default {
  name: "FormInput",
  components: { InfoExclamationMark },
  emits: ["input", "change"],
  props: {
    hasError: {
      type: Boolean,
      default: false,
    },
    infoText: {
      type: String,
      default: "",
    },
    infoTooltip: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      required: true,
    },
    maxlength: {
      type: Number,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    sideBox: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: false,
      default: "text",
    },
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>

<template>
  <div :class="{ 'side-box__row d-flex align-items-center mt-3': sideBox }">
    <div
      class="font-weight-light mb-1"
      :class="{
        'side-box__content__label mr-3': sideBox,
        'text-left': !sideBox,
      }"
    >
      {{ label }}
    </div>
    <div
      class="custom-control__custom-input"
      :class="{
        'has-error': hasError,
        'side-box__content__input': sideBox,
        'w-100': !sideBox,
        disabled: disabled,
      }"
    >
      <input
        :disabled="disabled"
        autofocus
        class="w-100"
        :maxlength="maxlength"
        :placeholder="placeholder"
        :type="type"
        :value="value"
        @input="$emit('input', $event.target.value)"
        @change="$emit('change', $event.target.value)"
      />
    </div>
    <info-exclamation-mark
      v-if="infoTooltip && infoTooltip"
      :info-text="infoText"
      :info-tooltip="infoTooltip"
    />
  </div>
</template>

<style scoped lang="scss"></style>
